import _ from 'underscore';

import Config from '../config';
import Task from '../model/task';
import View from './view';





const defaultFilters = { 
    title: '',
    contract_id: '',
    organization_id: null, 
    news_type_id: '',
    category_id: '',
    confirmed: '1', 
    assigned_status: '',
    assigned_organization_id: 0, 
    assigned_user_id: 0,
    assigned_user_fio: '',
    attachments: [],
};

let Filters; export default Filters = View.extend( {

    initialize(options) {
        View.prototype.initialize.call( this, options );
        this.model = new Filters.Model( defaultFilters );
    },

    serialize() {
        return {
            types: this.options.types.toJSON().filter( type =>
                type.role_ids == null ||
                type.role_ids.includes( Config.role() ) ||
                type.role_ids.includes( +Config.role() ) ),
        };
    },

    events: {

        'click .-clear-filters'() {
            this.model.clear( { silent: true, } );
            this.model.set( { ...defaultFilters } );
        },

    },

    afterRender() {
        if (!this.model) return;

        this.stopListening( this.model );

        const fn = () => this.trigger( 'filter', this.model.toJSON() );

        const { title, ...ordinaryFilters } = defaultFilters;
        const eventNames = Object.keys( ordinaryFilters )
            .map( prop => `change:${prop}` )
            .join( ' ' );
        this.listenTo( this.model, eventNames, _.debounce( fn, 100 ) );
        this.listenTo( this.model, 'change:title', _.debounce( fn, 300 ) );
    },

    focus() {
        this.$( '[name=title]' ).focus();
    },

}, {

    defaultFilters() {
        return { ...defaultFilters };
    },

    Model: Task.extend( {
        computeds: {

            ...Task.prototype.computeds,

            changed: {
                deps: ['title', 'confirmed', 
                    'contract_id', 'organization_id', 'news_type_id', 'category_id',
                    'assigned_status', 'assigned_user', 'assigned_organization_id'],
                get() {
                    // Task, not Model:
                    // Task is enough for diff() call;
                    // and usage of Model will produce
                    // infinite recursion at momemnt of 
                    // computing "changed" for a new Model.
                    const original = new Task( defaultFilters );
                    const diff = this.diff( original );
                    return !!diff.length;
                }
            }

        }
    } ),

} );


// WEBPACK FOOTER //
// ./src/js/view/tasks.filter.js